var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.data),function(item){return _c('div',{key:item.key},[_c('div',[_c('b',[_vm._v(_vm._s(item.key))]),_vm._v(": "+_vm._s(item.value)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }